module.exports = __webpack_public_path__ + "img/google.0b024359.png";